import type { MaterialFilters, PaginatedResponse } from '../../../features/materials/api';

// この商品に紐付いた素材を「ページングを最後まで辿って」集約する。
// limit 依存を排し、件数 (count) と source_url 集合 (アップロード済み判定用) を返す。
// ※ 画像クリックの選択フロー (handleAddToSelection) が使う組織スコープの一覧とは
//   別データソース。商品スコープのアップロード状態判定にのみ使う。
export async function collectProductLinkedMaterials(
  fetcher: (p: { limit?: number; cursor?: string | null; filters?: MaterialFilters }) => Promise<PaginatedResponse<any>>,
  filters: MaterialFilters,
): Promise<{ count: number; sourceUrls: Set<string> }> {
  const sourceUrls = new Set<string>();
  let cursor: string | null = null;
  let count = 0;
  let first = true;
  do {
    const page = await fetcher({ limit: 200, cursor, filters });
    if (first) {
      count = page.total_count ?? page.items.length;
      first = false;
    }
    for (const m of page.items) {
      for (const u of [m.source_url, m.preview_url, m.previewUrl]) {
        if (u) sourceUrls.add(u);
      }
    }
    cursor = page.has_more ? (page.next_cursor ?? null) : null;
  } while (cursor);
  return { count, sourceUrls };
}
